import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import ResourceFloorPlan from "./index";
import { FloorPlanInfo, IFetchFloorPlanRequest } from "@/services/resource-service/entity/FloorplanEntity";
import { baContainer } from "@/ioc";
import { IFilterResource, IResourceService, TokenIResourceService } from "@/services";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { updateFilterResource } from "@/redux/slices/resources/ResourceSlice";

const mapDispatchToProps = (dispatch : Dispatch)  => {
  const resourceService: IResourceService = baContainer.resolve(
    TokenIResourceService
  );
  return {
    onFetchResourceFloorPlan: (
      request: IFetchFloorPlanRequest
    ): Promise<FloorPlanInfo | null> => {
      return resourceService
        .fetchResourceFloorPlan(request)
        .then((resp: HttpResponse<FloorPlanInfo>) => {
          if (!resp.error) {
            return resp.data;
          } else {
            return null;
          }
        });
    },
    updateFilterResource: (filter: IFilterResource) => {
      dispatch(updateFilterResource(filter))
    }
  }
};

export default connect(null, mapDispatchToProps)(ResourceFloorPlan);
